/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { useParams } from 'react-router-dom';
import { validate as uuidValidate } from 'uuid';

import { HTTPError } from '@/components/HTTPError';
import { UpdateUserPage } from '@/pages/UpdateUser/UpdateUserPage';

export function UpdateUserRoute() {
  const { userID } = useParams<'userID'>();

  if (!userID || !uuidValidate(userID)) {
    return <HTTPError httpStatus="404" />;
  }

  return <UpdateUserPage userId={userID} />;
}
